import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1$1 from '@helix/platform/record/api';
import { RX_RECORD_DEFINITION } from '@helix/platform/record/api';
import { isEmpty } from 'lodash';
import { shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@helix/platform/shared/api';
import { RX_BUNDLE, DataPage } from '@helix/platform/shared/api';
import { of } from 'rxjs';

const RX_WEB_API_DEFINITION = {
    webApiConnections: {
        recordDefinitionName: 'WebAPI Connection',
        fields: {
            authentication: 70034,
            hostname: 70030,
            id: RX_RECORD_DEFINITION.coreFieldIds.id,
            name: RX_RECORD_DEFINITION.coreFieldIds.description,
            port: 70031
        }
    }
};

class RxWebApiDefinitionService {
    constructor(httpClient, rxCommandFactoryService) {
        this.httpClient = httpClient;
        this.renameCommand = rxCommandFactoryService.forResourceType('com.bmc.arsys.rx.application.rule.command.RenameWebApiDefinitionCommand');
    }
    create(webApiDefinitionName) {
        return this.httpClient.post(this.getUrl(), webApiDefinitionName, { observe: 'response' });
    }
    get(webApiDefinitionName, options) {
        return this.httpClient.get(this.getUrl(webApiDefinitionName), options);
    }
    getNew() {
        return of({
            allowOverlay: false,
            description: '',
            guid: null,
            lastChangedBy: null,
            lastUpdateTime: null,
            name: '',
            overlayDescriptor: null,
            overlayGroupId: null,
            requestDefinitions: [],
            scope: RX_BUNDLE.definitionScopeTypes.bundle
        });
    }
    rename(oldWebApiDefinitionName, newWebApiDefinitionName) {
        return this.renameCommand.execute({
            name: oldWebApiDefinitionName,
            newName: newWebApiDefinitionName
        });
    }
    update(webApiDefinition) {
        return this.httpClient.put(this.getUrl(webApiDefinition.name), webApiDefinition);
    }
    getUrl(webApiDefinitionName) {
        return webApiDefinitionName
            ? `/api/rx/application/webapi/webapidefinition/${encodeURIComponent(webApiDefinitionName)}`
            : '/api/rx/application/webapi/webapidefinition';
    }
}
RxWebApiDefinitionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionService, deps: [{ token: i1.HttpClient }, { token: i2.RxCommandFactoryService }], target: i0.ɵɵFactoryTarget.Injectable });
RxWebApiDefinitionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.RxCommandFactoryService }]; } });

class RxWebApiDefinitionCacheService {
    constructor(rxRecordInstanceDataPageService, rxWebApiDefinitionService) {
        this.rxRecordInstanceDataPageService = rxRecordInstanceDataPageService;
        this.rxWebApiDefinitionService = rxWebApiDefinitionService;
        this.consumers = new Set();
        this.webApiConnections$ = null;
        this.webApiDefinitionCache = new Map();
    }
    getWebApiConnections() {
        if (!this.webApiConnections$) {
            this.webApiConnections$ = this.rxRecordInstanceDataPageService
                .post({
                params: {
                    recorddefinition: RX_WEB_API_DEFINITION.webApiConnections.recordDefinitionName,
                    startIndex: 0,
                    pageSize: -1
                }
            })
                .pipe(shareReplay(1));
        }
        return this.webApiConnections$;
    }
    getWebApiDefinition(webApiDefinitionName) {
        if (!this.webApiDefinitionCache.has(webApiDefinitionName)) {
            const webApiDefinition$ = this.rxWebApiDefinitionService.get(webApiDefinitionName).pipe(shareReplay(1));
            this.webApiDefinitionCache.set(webApiDefinitionName, webApiDefinition$);
        }
        return this.webApiDefinitionCache.get(webApiDefinitionName);
    }
    registerConsumer(consumerDestroy$) {
        this.consumers.add(consumerDestroy$);
        consumerDestroy$.subscribe(() => {
            this.consumers.delete(consumerDestroy$);
            if (isEmpty(this.consumers)) {
                this.clearCache();
            }
        });
    }
    clearCache() {
        this.webApiConnections$ = null;
        this.webApiDefinitionCache.clear();
    }
}
RxWebApiDefinitionCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionCacheService, deps: [{ token: i1$1.RxRecordInstanceDataPageService }, { token: RxWebApiDefinitionService }], target: i0.ɵɵFactoryTarget.Injectable });
RxWebApiDefinitionCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.RxRecordInstanceDataPageService }, { type: RxWebApiDefinitionService }]; } });

class RxWebApiDefinitionDataPageService extends DataPage {
    constructor(injector) {
        super(injector, 'com.bmc.arsys.rx.application.webapi.datapage.WebApiDefinitionDataPageQuery');
        this.injector = injector;
    }
}
RxWebApiDefinitionDataPageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionDataPageService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
RxWebApiDefinitionDataPageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionDataPageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxWebApiDefinitionDataPageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { RX_WEB_API_DEFINITION, RxWebApiDefinitionCacheService, RxWebApiDefinitionDataPageService, RxWebApiDefinitionService };
